import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import './Panel.css'
import Button from 'Components/Button/Button';
import FilterIcon from '../../Components/SideBar/assets/icons/filterIcon.png';
import ToolbarMenu from 'Components/ToolbarMenu/ToolbarMenu';
import { getFromLocalStorage } from 'Components/AutomaticallyListedAttributesGrid/AutomaticallyListedAttributesGrid';

const Panel = React.forwardRef(({
    id,
    children,
    style,
    className,
    setUpdating = false,
    setInserting = false,
    inserting = false,
    updating = false,
    enableEdit = false,
    canEdit = false,
    canSaveAfterEdit = true,
    forcedEdit = false,
    putFunction,
    enableNewRecord = false,
    canNewRecord = false,
    canSaveAfterNewRecord = true,
    canSaveAfterNewRecordForced = false,
    forcedNewRecord = false,
    forcedDeleteButton = false,
    postFunction,
    enableDelete = false,
    canDelete = false,
    newRecordNameButton = 'Novo',
    updateNameButton = 'Editar',
    insertNameButton = 'Adicionar',
    deleteNameButton = 'Excluir',
    saveNameButton = 'Salvar',
    cancelNameButton = 'Cancelar',
    cancelFunction,
    deleteFunction,
    canViewCRUD = false,
    readOnly,
    recordsSelected,
    viewOnlyOneRecordCRUD = false,
    restrictPanel = false,
    messageRestrictPanel,
    records,
    panelAttributesToShowInDetail,
    titlePage,
    resetVariables,
    reloadFilter,
    componentLeftButtons,
    componentLeftFilter,
    componentRightFilter,
    componentRightButtons,
    titleStyleAdditional,
    subtitlesPanelBottom,
    filterAction,
    setHigherRegisterSelected,
    resetHigherRegisterInserting = false,
    dataListedAttributes,
    attributeList,
    withoutCrud,
    onUpdateIdSelected,
    enableCancelButton = true,
    allButtonsToolBar = false,
    buttonsToolBar,
    isGrid,
    localStorageName,
    needCheckedCheckboxToValidateMandatoryGrid
}, ref) => {

    const buttonDeleteSyled = {
        minWidth: '80px',
        padding: '0px 5px 0px 5px',
        float: 'right',
        color: !canDelete ? '#201b2387' : '#f21818',
        textAlign: 'center',
        fontWeight: '600',
        fontSize: '0.8em'
    };

    const buttonCancelSyled = {
        minWidth: '80px',
        padding: '0px 5px 0px 5px',
        float: 'right',
        color: '#f21818',
        fontWeight: '600',
        textAlign: 'center',
        fontSize: '0.8em'
    };

    const buttonInsertSyled = {
        minWidth: '80px',
        padding: '0px 5px 0px 5px',
        float: 'right',
        color: canNewRecord ? 'green' : '#201b2387',
        fontWeight: '600',
        textAlign: 'center',
        fontSize: '0.8em'
    };

    const buttonUpdateSyled = {
        minWidth: '80px',
        marginRight: '5px',
        padding: '0px 5px 0px 5px',
        float: 'right',
        color: canEdit ? 'green' : '#201b2387',
        fontWeight: '600',
        textAlign: 'center',
        fontSize: '0.8em'
    };

    const buttonSaveOrEditSyled = {
        minWidth: '80px',
        padding: '0px 5px 0px 5px',
        float: 'right',
        color: mandatoryAttributesPending() ? '#201b2387' : 'green',
        fontWeight: '600',
        textAlign: 'center',
        fontSize: '0.8em'
    };

    const titleControlPanelStyle = {
        fontSize: '1.2em',
        width: '100%',
        textAlign: 'center',
        display: 'flex',
        minHeight: '56px',
        maxHeight: '56px'
    };

    const titleStyle = {
        textAlign: 'center',
        display: 'flex',
        minHeight: '56px',
        maxHeight: '56px',
        overflow: 'hidden',
        marginLeft: '10px',
        fontSize: '1em',
        alignItems: 'center',
        flexShrink: '0',
        whiteSpace: 'nowrap',
        ...titleStyleAdditional
    };

    const textControlPanel = {
        textAlign: 'center',
        alignItems: 'center',
        justifyContent: 'space-evenly',
        display: 'flex',
        marginRight: '10px'
    };

    function mandatoryAttributesPending() {
        let pending = false;

        //Force
        if ((canSaveAfterNewRecordForced && inserting)) {
            return false;
        }

        // Bloqueio geral
        if ((!canSaveAfterNewRecord && inserting) || (!canSaveAfterEdit && updating)) {
            return true;
        }

        // =====================================================
        // 🔹 1) TELA NORMAL (SEM GRID)
        // =====================================================
        if (!isGrid) {
            if (
                dataListedAttributes?.[0]?.constructorList?.length > 0 &&
                attributeList?.length > 0
            ) {
                dataListedAttributes[0].constructorList.forEach(element => {
                    const attributeFrontend =
                        attributeList.find(obj => obj.name === element.field) || {};

                    const isMandatory =
                        attributeFrontend.isMandatory === 'S' ||
                        element.isMandatory === 'S';

                    const isVisible =
                        !(
                            attributeFrontend.isVisible === false ||
                            attributeFrontend.isVisible == 'N'
                        ) &&
                        !(
                            element.visible === false ||
                            element.visible == 'N'
                        );

                    const value = attributeFrontend.value;

                    const hasValue =
                        value !== null &&
                        value !== undefined &&
                        value !== '';

                    if (isMandatory && isVisible && !hasValue) {
                        pending = true;
                    }
                });
            }
        }

        // =====================================================
        // 🔹 2) GRID (LOCAL STORAGE)
        // =====================================================
        if (isGrid && localStorageName) {
            const rows = getFromLocalStorage(localStorageName);

            rows.forEach(row => {
                row.constructorList.forEach(attributeBackend => {
                    const attributeFrontend =
                        attributeList.find(obj => obj.name === attributeBackend.field) || {};

                    const isMandatory =
                        attributeFrontend.isMandatory === 'S' ||
                        attributeBackend.isMandatory === 'S';

                    const isVisible =
                        !(
                            attributeFrontend.isVisible === false ||
                            attributeFrontend.isVisible == 'N'
                        ) &&
                        !(
                            attributeBackend.visible === false ||
                            attributeBackend.visible == 'N'
                        );

                    // -------------------------
                    // 🔹 Pega valor certo
                    // -------------------------
                    let value = attributeBackend.argument;
                    const isCheckbox =
                        attributeBackend.columnType?.toUpperCase() === 'CHECKBOX';

                    if (isCheckbox) {
                        value = attributeBackend.checked;
                    }

                    // -------------------------
                    // 🔹 Regra de preenchimento
                    // -------------------------
                    let hasValue;

                    if (isCheckbox) {
                        hasValue = value === 'S'; // só marcado conta
                    } else {
                        hasValue =
                            value !== null &&
                            value !== undefined &&
                            value !== '';
                    }

                    // =====================================================
                    // 🔥 needChecked → depende de um checkbox específico
                    // =====================================================
                    let mustValidate = true;

                    if (needCheckedCheckboxToValidateMandatoryGrid) {
                        const hasRowWithChecked = rows.some(row =>
                            row.constructorList.some(attr =>
                                attr.field === 'id' &&
                                attr.columnType?.toUpperCase() === 'CHECKBOX' &&
                                attr.checked === 'S'
                            )
                        );

                        if (!hasRowWithChecked) {
                            pending = true; // já bloqueia tudo
                        }

                        const triggerCheckbox = row.constructorList.find(attr =>
                            attr.field === 'id' &&
                            attr.columnType?.toUpperCase() === 'CHECKBOX'
                        );

                        mustValidate = triggerCheckbox?.checked === 'S';
                    }

                    if (isMandatory && isVisible && mustValidate && !hasValue) {
                        pending = true;
                    }
                });
            });
        }

        return pending;
    }

    function getSetUpdateButton() {
        if (forcedEdit || enableEdit) {
            return <Button
                clickMethod={() => {
                    if (setUpdating) {
                        setUpdating(true);
                    }
                }}
                buttonName={updateNameButton}
                style={buttonUpdateSyled}
                disabled={!canEdit}
            />
        }
    }

    function getSetInsertButton() {
        if (forcedNewRecord || enableNewRecord) {
            return <Button
                clickMethod={() => {
                    if (setInserting) {
                        if (onUpdateIdSelected) {
                            onUpdateIdSelected([])
                        }

                        setInserting(true)

                        if (resetVariables) {
                            resetVariables()
                        }

                        if (resetHigherRegisterInserting) {
                            setHigherRegisterSelected([])
                        }
                    }
                }}
                buttonName={newRecordNameButton}
                style={buttonInsertSyled}
                disabled={!canNewRecord}
            />
        }
    }

    function getDeleteButton() {
        if (!inserting && !updating && enableDelete) {
            return <Button
                clickMethod={() => {
                    deleteFunction(recordsSelected);
                    if (reloadFilter) {
                        reloadFilter(true);
                    }

                    if (onUpdateIdSelected) {
                        onUpdateIdSelected([])
                    }
                }
                }
                buttonName={deleteNameButton}
                style={buttonDeleteSyled}
                disabled={!canDelete}
            />
        }
    }

    function getEditButton() {
        if (!inserting && updating && canEdit) {
            return <Button
                clickMethod={async () => {
                    const returnValue = await putFunction();

                    if (returnValue || returnValue === null) {
                        if (setUpdating) {
                            setUpdating(false);
                        }

                        if (reloadFilter) {
                            await reloadFilter(true);
                        }
                    }
                }
                }
                disabled={mandatoryAttributesPending()}
                buttonName={saveNameButton}
                style={buttonSaveOrEditSyled}
            />
        }
    }

    function getNewRecordButton() {
        if (inserting && !updating) {
            return <Button
                clickMethod={async () => {
                    const returnValue = await postFunction();

                    if (returnValue || returnValue === null) {
                        if (setInserting) {
                            setInserting(false);
                        }

                        if (reloadFilter) {
                            await reloadFilter(true);
                        }
                    }
                }
                }
                buttonName={insertNameButton}
                disabled={mandatoryAttributesPending()}
                style={buttonSaveOrEditSyled}
            />
        }
    }

    function getCancelButton() {
        if ((inserting || updating) && enableCancelButton) {
            return <Button
                clickMethod={async () => {
                    if (cancelFunction) {
                        await cancelFunction();
                    }

                    if (setInserting) {
                        setInserting(false);
                    }

                    if (setUpdating) {
                        setUpdating(false);
                    }

                    if (reloadFilter) {
                        reloadFilter(true);
                    }
                }
                }
                buttonName={cancelNameButton}
                style={buttonCancelSyled}
            />
        }
    }

    function filterAtributte() {
        if (!filterAction) {
            return null
        }
        return (
            <img src={FilterIcon}
                style={{
                    maxHeight: '17px',
                    maxWidth: '17px',
                    width: '17px',
                    margin: '0px',
                    cursor: 'pointer',
                    marginLeft: '5px'
                }}
                onClick={filterActionUpdate}
            />
        )
    }

    function filterActionUpdate() {
        filterAction(true)
    }

    let buttons;
    let buttonDelete;
    if (!readOnly) {
        if (!inserting || !updating) {
            buttons =
                <>
                    {getSetUpdateButton()}
                    {getSetInsertButton()}
                </>
        }

        if (inserting || updating) {
            buttons =
                <>
                    {getEditButton()}
                    {getNewRecordButton()}
                    {getCancelButton()}
                </>
        }

        if ((forcedDeleteButton || (recordsSelected && recordsSelected.length === 1) || enableDelete) && (!inserting || !updating)) {
            buttonDelete =
                <>
                    {getDeleteButton()}
                </>
        }
    }

    const allButtons = [
        ...(componentLeftButtons ? React.Children.toArray(componentLeftButtons) : []),
        ...(buttonDelete ? [buttonDelete] : []),
        ...(buttons ? React.Children.toArray(buttons) : []),
        ...(componentRightButtons ? React.Children.toArray(componentRightButtons) : [])
    ]

    const [visibleButtons, setVisibleButtons] = useState([])
    const [overflowButtons, setOverflowButtons] = useState([])
    const panelRef = useRef(null)
    const invisiblePanelRef = useRef(null)
    const measureRef = useRef(null)

    const OVERFLOW_WIDTH = 40

    const calculateVisibleButtons = () => {
        const panel = panelRef.current
        const measure = measureRef.current
        const invisiblePanel = invisiblePanelRef.current

        if (!panel || !measure) return

        const availableWidth = measure.clientWidth - OVERFLOW_WIDTH

        let usedWidth = 0
        const children = Array.from(invisiblePanel.children)

        const visible = []
        const overflow = []

        children.forEach((child, index) => {
            const width = child.offsetWidth

            if (usedWidth + width <= availableWidth) {
                usedWidth += width
                visible.push(allButtons[index])
            } else {
                overflow.push(allButtons[index])
            }
        })

        setVisibleButtons(visible)
        setOverflowButtons(overflow)
    }

    useLayoutEffect(() => {
        requestAnimationFrame(() => {
            calculateVisibleButtons()
        })
    }, [allButtons])

    useEffect(() => {
        if (!panelRef.current) return

        const observer = new ResizeObserver(() => {
            calculateVisibleButtons()
        })

        observer.observe(panelRef.current)

        return () => observer.disconnect()
    }, [])

    function getPanelContent() {
        if (!canViewCRUD) {
            return;
        }

        if (viewOnlyOneRecordCRUD && recordsSelected && recordsSelected.length > 1) {
            return (
                <Panel style={titleControlPanelStyle}>
                    <Panel style={titleStyle}>
                        {componentLeftFilter ? componentLeftFilter : null}
                        <div style={{ display: 'flex', fontWeight: 'bold' }}>
                            {titlePage}
                        </div>
                        {filterAtributte()}
                        {componentRightFilter ? componentRightFilter : null}
                    </Panel>
                    <Panel style={textControlPanel}>
                        Selecione somente 01 registro.
                    </Panel>
                </Panel>
            )
        }

        if (restrictPanel) {
            return (
                <Panel style={titleControlPanelStyle}>
                    <Panel style={titleStyle}>
                        {componentLeftFilter ? componentLeftFilter : null}
                        <div style={{ display: 'flex', fontWeight: 'bold' }}>
                            {titlePage}
                        </div>
                        {filterAtributte()}
                        {componentRightFilter ? componentRightFilter : null}
                    </Panel>
                    <Panel style={textControlPanel}>
                        {messageRestrictPanel}
                    </Panel>
                </Panel>
            )
        }

        return (
            <Panel ref={panelRef} style={titleControlPanelStyle} id={canViewCRUD ? `main-panel-crud` : ''}>
                <Panel style={titleStyle}>
                    {componentLeftFilter ? componentLeftFilter : null}
                    <div style={{ display: 'flex', fontWeight: 'bold' }}>
                        {titlePage}
                    </div>
                    {filterAtributte()}
                    {componentRightFilter ? componentRightFilter : null}
                </Panel>
                {/* 🔎 Container invisível só para medir */}
                <div
                    ref={invisiblePanelRef}
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        overflow: 'hidden',
                        gap: '4px',
                        marginRight: '5px',
                        flexGrow: 1,
                        justifyContent: 'flex-end',
                        position: 'absolute',
                        visibility: 'hidden',
                        height: 0,
                        overflow: 'hidden',
                    }}
                >
                    {allButtons.map((btn, index) => (
                        <div key={index} style={{ display: 'inline-flex' }}>
                            {btn}
                        </div>
                    ))}
                </div>
                <div
                    ref={measureRef}
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        overflow: 'hidden',
                        gap: '4px',
                        marginRight: '5px',
                        flexGrow: 1,
                        justifyContent: 'flex-end'

                    }}
                >
                    {visibleButtons.map((btn, index) => (
                        <div key={index} style={{ display: 'flex', gap: '2px' }}>
                            {btn}
                        </div>
                    ))}

                    {overflowButtons.length > 0 && (
                        <ToolbarMenu buttonsToolBar={overflowButtons} />
                    )}
                </div>

            </Panel>
        )

    }

    function getSubtitlesPanelContent() {
        if (subtitlesPanelBottom) {
            return (
                subtitlesPanelBottom
            )
        }
    }

    const subtitlesPanelContent = getSubtitlesPanelContent()

    return (
        <>
            <div ref={ref} style={style} id='main-panel' className={className}>
                {withoutCrud ? null : getPanelContent()}
                {children}
            </div>
            {subtitlesPanelContent}
        </>
    );
});

export default Panel;
